<template>
  <el-config-provider :locale="config.locale" :size="config.size">
    <router-view />
  </el-config-provider>
</template>

<script>
import { reactive, toRefs } from 'vue'
import { useI18n } from './plugins/i18n'

export default {
  setup() {
    const { messages, locale } = useI18n()
    const state = reactive({
      config: {
        locale: {
          name: locale,
          el: messages[locale].el
        },
        size: 'large'
      }
    })
    return {
      ...toRefs(state)
    }
  }
}
</script>

<style>

</style>
